import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import type { SxProps, Theme } from "@mui/material/styles";
import AppIconButton from "./form/AppIconButton";
import { isDocsPath, resolveHelpTarget } from "../navigation/helpTargets";

/** Opens the user-guide page (and tab heading) that explains the screen the user is on. */
export default function HelpButton({ iconSx }: { iconSx?: SxProps<Theme> }) {
  const { t } = useTranslation();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  if (isDocsPath(pathname)) {
    return null;
  }

  const label = t("docs.helpForPage");
  return (
    <Tooltip title={label}>
      <AppIconButton size="small" disableRipple aria-label={label} onClick={() => navigate(resolveHelpTarget(pathname, search))}>
        <Icon sx={iconSx}>help_outline</Icon>
      </AppIconButton>
    </Tooltip>
  );
}
